import { Card, CardContent, CardHeader } from "@/components/ui/card";

export function ProgramCardSkeleton() {
  return (
    <Card className="w-full max-w-2xl">
      <CardHeader>
        {/* Header skeleton */}
        <div className="h-8 bg-gray-200 rounded animate-pulse w-64"></div>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Booking type buttons skeleton */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="h-10 bg-gray-200 rounded-lg animate-pulse"></div>
          <div className="h-10 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>

        {/* Program selection skeleton */}
        <div className="flex flex-col gap-2">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
          <div className="ml-1 h-10 bg-gray-200 rounded border animate-pulse"></div>
        </div>

        {/* Session selection skeleton */}
        <div className="flex flex-col gap-2">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
          <div className="ml-1 flex flex-col gap-4">
            <div className="h-10 bg-gray-200 rounded border animate-pulse"></div>

            {/* Session details skeleton */}
            <div className="rounded-lg border border-gray-300 bg-gray-200 p-4 space-y-3">
              <div className="space-y-2">
                <div className="h-4 bg-gray-300 rounded animate-pulse w-48"></div>
                <div className="h-4 bg-gray-300 rounded animate-pulse w-64"></div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
